import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Path, Svg } from 'react-native-svg';

import Avatar from '@/components/Avatar';

type SponsorAppointmentSummaryCardProps = {
  sponsorName: string | null | undefined;
  sponsorRole: string | null | undefined;
  sponsorPhotoUrl: string | null | undefined;
  scheduledForLabel: string;
  dateLabel: string;
  atLabel: string;
  timeLabel: string;
};

const CalendarIcon = () => (
  <Svg width='24' height='24' viewBox='0 0 20 20' fill='none'>
    <Path
      d='M12.6289 3.07715V5.55658M6.60938 3.07715V5.55658'
      stroke='#151515'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.0679 4.22021L6.17256 4.2209C4.14713 4.2209 2.88281 5.34879 2.88281 7.42193V13.663C2.88281 15.7689 4.14713 16.9229 6.17256 16.9229L13.062 16.9222C15.0933 16.9222 16.3516 15.7883 16.3516 13.7145V7.42125C16.3576 5.34811 15.0993 4.22021 13.0679 4.22021Z'
      stroke='#151515'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M6.26953 9.53125H6.27786M6.26953 12.4097H6.27786M9.61328 9.53125H9.62161M9.61328 12.4097H9.62161M12.9492 9.53125H12.9576M12.9492 12.4097H12.9576'
      stroke='#151515'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);

export default function SponsorAppointmentSummaryCard({
  sponsorName,
  sponsorRole,
  sponsorPhotoUrl,
  scheduledForLabel,
  dateLabel,
  atLabel,
  timeLabel,
}: SponsorAppointmentSummaryCardProps) {
  return (
    <View style={styles.card}>
      <View style={styles.sponsorInfoRow}>
        <View style={styles.sponsorAvatarSquare}>
          <Avatar
            uri={sponsorPhotoUrl ?? null}
            size={40}
            style={{ borderRadius: 12 }}
            borderWidth={0}
          />
        </View>
        <View style={styles.sponsorDetails}>
          <Text style={styles.sponsorNameText}>{sponsorName}</Text>
          <Text style={styles.sponsorRoleText}>{sponsorRole}</Text>
        </View>
      </View>

      <View style={styles.scheduleInfoRow}>
        <CalendarIcon />
        <Text style={styles.scheduleText}>
          {scheduledForLabel} <Text style={styles.scheduleTextBold}>{dateLabel}</Text> {atLabel}{' '}
          <Text style={styles.scheduleTextBold}>{timeLabel}</Text>
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    padding: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#FFFFFF',
    gap: 16,
  },
  sponsorInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    width: '100%',
  },
  sponsorAvatarSquare: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#C4C2BA',
    overflow: 'hidden',
    width: 40,
    height: 40,
  },
  sponsorDetails: {
    flexDirection: 'column',
    flex: 1,
    gap: 4,
  },
  sponsorNameText: {
    color: '#151515',
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    lineHeight: 19.6,
  },
  sponsorRoleText: {
    color: '#757C85',
    fontFamily: 'Inter_500Medium',
    fontSize: 12,
    lineHeight: 12,
  },
  scheduleInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  scheduleText: {
    color: '#151515',
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    lineHeight: 19.6,
    flex: 1,
  },
  scheduleTextBold: {
    fontFamily: 'Inter_700Bold',
    color: '#151515',
  },
});
